
import { Component, Vue } from 'vue-property-decorator';
import {
  EGlobalTransactionsDateFilter,
  GetRangedPagedTransactionsDocument,
  GetRangedPagedTransactionsQuery,
  GlobalTransaction
} from '@/modules/common/services/graphql/server/server.sdk';
import { WarrenModules } from '@/types/navigation';
import { HomeWidget } from '@/modules/home/components/HomeWidget';
import { HomeWidgetLoader } from '@/modules/home/components/HomeWidgetLoader';
import { GlobalTransactionsSummary } from '@/modules/transaction/components/GlobalTransactionsSummary';
import * as trackEvents from './track-events';

@Component({
  components: {
    HomeWidget,
    HomeWidgetLoader,
    GlobalTransactionsSummary
  }
})
export default class HomeTransactions extends Vue {
  readonly module = WarrenModules.Home;
  transactions: GlobalTransaction[] = [];
  hasError = false;
  isLoading = true;
  hasMore = false;

  created() {
    this.listTransactions();
  }

  reloadTransactions() {
    this.listTransactions();
    trackEvents.trackReloadTransactionErrorClick();
  }

  async listTransactions() {
    this.isLoading = true;
    this.hasError = false;

    try {
      const { data } =
        await this.$apollo.query<GetRangedPagedTransactionsQuery>({
          query: GetRangedPagedTransactionsDocument,
          variables: {
            pageSize: 3,
            pageIndex: 1,
            module: WarrenModules.Overview,
            datePeriod: EGlobalTransactionsDateFilter.All,
            dateFormat: 'DD/MM/YYYY'
          }
        });
      this.setTransactionsData(data);

      const totalPages = data.transaction?.rangedPagedList?.page?.amount || 0;
      this.hasMore = totalPages > 1;
    } catch {
      this.hasError = true;
      trackEvents.trackTransactionErrorLoad();
    } finally {
      this.isLoading = false;
    }
  }

  private setTransactionsData(data: GetRangedPagedTransactionsQuery) {
    const transactionsData = data.transaction?.rangedPagedList?.transactions!;
    this.transactions = transactionsData;
  }

  trackTransactionDetails(type: string) {
    trackEvents.trackTransactionDetailsEvent(type);
  }

  trackTransactionsPageNavigation() {
    trackEvents.trackViewMoreTransactionsEvent();
  }
}
